<template>
  <div>
    <base-page-heading
      title="New Quote Template"
      show-back-button
    />
    <div class="content">
      <b-row>
        <b-col>
          <quote-templates-form
            @on-submit="createTemplate"
            @on-save="onSave"
            @on-cancel="onCancel"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import QuoteTemplatesForm from '@/components/admin/quoteTemplates/Form.vue';

export default {
  name: 'QuoteTemplatesNew',
  components: {
    QuoteTemplatesForm,
  },
  methods: {
    createTemplate(data, handleCreate) {
      handleCreate(this.$quoteTemplatesAPI.create(data));
    },
    onSave() {
      this.$router.push({ name: 'quote-templates' });
    },
    onCancel() {
      this.$router.push({ name: 'quote-templates' });
    },
  },
};
</script>
